// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"78483008","455":"eb26abf2"}[chunkId] + ".chunk.js";
};